import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useEsri, useMap } from '../hooks'

import { useMedia } from '../../hooks/useMedia'

import { MOBILE_SCREEN_WIDTH } from '../../constants'
import { PROXY_URL } from '../constants'

import styles from './Map.module.css'

const esriReqs = ['esri/Map', 'esri/views/MapView', 'esri/core/urlUtils']

const Map = ({ children, basemap, padding }) => {
  const [ready, { Map, MapView, urlUtils }] = useEsri(esriReqs)
  const [{ map, view }, setMapAndView] = useMap()
  const isDesktop = useMedia(`(min-width: ${MOBILE_SCREEN_WIDTH}px)`)

  useEffect(() => {
    if (ready) {
      urlUtils.addProxyRule({
        urlPrefix: 'www.horrycountysc.gov/gisweb/',
        proxyUrl: PROXY_URL,
      })
      urlUtils.addProxyRule({
        urlPrefix: 'traffic.arcgis.com',
        proxyUrl: PROXY_URL,
      })

      const map = new Map({
        basemap: basemap || 'streets-vector',
      })

      const viewOptions = {
        container: 'map',
        map: map,
        center: [-78.938501, 33.933995],
        zoom: 11,
      }

      if (padding) {
        viewOptions.ui = {
          padding,
        }
      }

      const view = new MapView(viewOptions)

      if (isDesktop) {
        view.popup.dockOptions.position = 'bottom-right'
        view.popup.actions.removeAll()
      } else {
        view.popup = null
      }
      setMapAndView(map, view)
    }
  }, [
    ready,
    Map,
    MapView,
    urlUtils,
    basemap,
    padding,
    setMapAndView,
    isDesktop,
  ])

  const kids = React.Children.map(children, (child) => {
    return React.cloneElement(child, { map, view })
  })

  return (
    <div className={styles.map} id="map">
      {view && map && kids}
    </div>
  )
}

export default withRouter(Map)
